import { Button } from "primereact/button";
import { Dropdown } from "primereact/dropdown";
import { InputText } from "primereact/inputtext";
import { useState } from "react";
import {
  genElDateObject,
  genElObject,
} from "@components/utils/EditorDialogElementGenerator";
import DepartmentSelectorDialog from "../../../dialogs/selectors/DepartmentSelectorDialog";
import JenisMinyakSelectorDialog from "../../../dialogs/selectors/JenisMinyakSelectorDialog";
import { STATUS_OPTIONS } from "../utils/permintaan-minyak-helpers";

const PermintaanMinyakFilter = (props) => {
  const { filterValue, setFilterValue, onClickRefresh } = props;

  const [showDepartmentSelector, setShowDepartmentSelector] = useState(false);
  const [showJenisMinyakSelector, setShowJenisMinyakSelector] = useState(false);

  // handle ui event section

  const handleOnConfirmDepartment = (event, datas) => {
    if (datas && datas.length > 0) {
      const department = datas[0];
      setFilterValue((prevData) => ({
        ...prevData,
        data_department: department,
        department_id: department.id,
      }));
      setShowDepartmentSelector(false);
    }
  };

  const handleOnConfirmJenisMinyak = (event, datas) => {
    if (datas && datas.length > 0) {
      const jenisMinyak = datas[0];
      setFilterValue((prevData) => ({
        ...prevData,
        data_jenis_minyak: jenisMinyak,
        jenis_minyak_id: jenisMinyak.id,
      }));
      setShowJenisMinyakSelector(false);
    }
  };

  // custom ui section

  const elTanggalDari = genElDateObject({
    field: "tanggal_dari",
    name: "Tanggal (Dari)",
    data: filterValue,
    setData: setFilterValue,
    primeFormat: "dd MM yy",
  });

  const elTanggalSampai = genElDateObject({
    field: "tanggal_sampai",
    name: "Tanggal (Sampai)",
    data: filterValue,
    setData: setFilterValue,
    primeFormat: "dd MM yy",
  });

  const elDepartment = genElObject({
    field: "department_id",
    name: "Department",
    value: filterValue.data_department ? filterValue.data_department.nama : "",
    onClick: () => setShowDepartmentSelector(true),
    onClear: () =>
      setFilterValue((prevData) => ({
        ...prevData,
        data_department: null,
        department_id: null,
      })),
  });

  const elJenisMinyak = genElObject({
    field: "jenis_minyak_id",
    name: "Jenis Minyak",
    value: filterValue.data_jenis_minyak
      ? filterValue.data_jenis_minyak.nama
      : "",
    onClick: () => setShowJenisMinyakSelector(true),
    onClear: () =>
      setFilterValue((prevData) => ({
        ...prevData,
        data_jenis_minyak: null,
        jenis_minyak_id: null,
      })),
  });

  return (
    <div className="row-between-end gap-4 w-full">
      <DepartmentSelectorDialog
        title={"Pilih Department"}
        visible={showDepartmentSelector}
        onHide={() => setShowDepartmentSelector(false)}
        onConfirm={handleOnConfirmDepartment}
      />

      <JenisMinyakSelectorDialog
        title={"Pilih Jenis Minyak"}
        visible={showJenisMinyakSelector}
        onHide={() => setShowJenisMinyakSelector(false)}
        onConfirm={handleOnConfirmJenisMinyak}
      />

      {/* filter component section */}
      <div className="row-start-end gap-4 w-full flex-wrap">
        <div className="w-full sm:w-[12rem]">{elTanggalDari}</div>
        <div className="w-full sm:w-[12rem]">{elTanggalSampai}</div>
        <div className="col-start-start gap-1 w-full sm:w-[12rem]">
          <label className="font-bold text-sm text-slate-500">Nomor</label>
          <InputText
            value={filterValue.nomor}
            onChange={(e) =>
              setFilterValue({ ...filterValue, nomor: e.target.value })
            }
            onKeyDown={(e) => {
              if (e.key === "Enter") {
                if (onClickRefresh) onClickRefresh();
              }
            }}
            className="w-full"
          />
        </div>
        <div className="col-start-start w-full sm:w-[13rem]">
          {elDepartment}
        </div>
        <div className="col-start-start w-full sm:w-[13rem]">
          {elJenisMinyak}
        </div>
        <div className="col-start-start gap-1 w-full sm:w-[12rem]">
          <label className="font-bold text-sm text-slate-500">Status</label>
          <Dropdown
            className="w-full"
            options={STATUS_OPTIONS}
            optionLabel="label"
            value={filterValue.status}
            onChange={(e) =>
              setFilterValue((prevData) => ({ ...prevData, status: e.value }))
            }
          />
        </div>
      </div>
      {/* refresh section */}
      <Button
        icon="pi pi-refresh"
        outlined
        rounded
        onClick={() => {
          if (onClickRefresh) onClickRefresh();
        }}
      />
    </div>
  );
};

export default PermintaanMinyakFilter;
